__turbopack_context__.v({
  "active": "fsOtpq_active",
  "badgeLabel": "fsOtpq_badgeLabel",
  "badgeRemove": "fsOtpq_badgeRemove",
  "dialogBackdrop": "fsOtpq_dialogBackdrop",
  "dialogClose": "fsOtpq_dialogClose",
  "dialogContent": "fsOtpq_dialogContent",
  "dialogFooter": "fsOtpq_dialogFooter",
  "dialogHandle": "fsOtpq_dialogHandle",
  "dialogHeader": "fsOtpq_dialogHeader",
  "dialogPopup": "fsOtpq_dialogPopup",
  "dialogTitle": "fsOtpq_dialogTitle",
  "divider": "fsOtpq_divider",
  "fadeIn": "fsOtpq_fadeIn",
  "filterBadge": "fsOtpq_filterBadge",
  "filterBadges": "fsOtpq_filterBadges",
  "filterCount": "fsOtpq_filterCount",
  "filtersButton": "fsOtpq_filtersButton",
  "header": "fsOtpq_header",
  "menuItem": "fsOtpq_menuItem",
  "menuPopup": "fsOtpq_menuPopup",
  "menuPositioner": "fsOtpq_menuPositioner",
  "rightSection": "fsOtpq_rightSection",
  "root": "fsOtpq_root",
  "slideUp": "fsOtpq_slideUp",
  "sortByLabel": "fsOtpq_sortByLabel",
  "sortContainer": "fsOtpq_sortContainer",
  "sortDropdown": "fsOtpq_sortDropdown",
  "sortOption": "fsOtpq_sortOption",
  "toggle": "fsOtpq_toggle",
  "toggleButton": "fsOtpq_toggleButton",
});
